import { memo, useEffect, useState } from "react";

import { Button } from "primereact/button";
import { Chart } from "primereact/chart";

import ChartDataLabels from 'chartjs-plugin-datalabels';

const cores = ['#2274a9', '#155b86', '#0f496e', '#0a3d5a', '#062e45', '#3498db', '#5ab8f0', '#72c4f3', '#89d0f6', '#a0dcf9', '#b7e8fc']

const options = {
    maintainAspectRatio: false,
    plugins: {
        datalabels: {
            align: 'center',
            anchor: 'center',
            formatter: (value, context) => {
                return String(parseInt(value / 3600)).padStart(2, '0') + ':' + String(parseInt(value / 60 % 60)).padStart(2, '0');
            },
            font: {
                size: 20,
                weight: 'bold'
            },
            color: "#f39c12"
        },
        title: {
            display: true,
            text: 'Gráfico de Paradas por Tipo',
            font: {
                size: 18
            }
        }
    },
}

export const GraficoParadas = memo(function GraficoParadas({ data }) {
    const [chartData, setChartData] = useState({});
    const [total, setTotal] = useState(0);
    const [col, setCol] = useState("p-col-6");

    const optionsPercent = {
        maintainAspectRatio: false,
        layout: {
            padding: 20
        },
        plugins: {
            datalabels: {
                align: 'end',
                anchor: 'center',
                formatter: (value, context) => {
                    return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(parseFloat(value / total * 100)) + '\n' + data.labels[context.dataIndex];
                },
                font: {
                    size: 18,
                    weight: 'bold'
                },
                color: "#f39c12"
            },
            legend: {
                display: true,
                padding: 40
            },
            title: {
                display: true,
                text: 'Gráfico de Paradas por Tipo %',
                font: {
                    size: 18
                }
            }
        },
    }

    useEffect(() => {
        let chartData = {}

        let dataChart = [];
        let totalGeral = 0;

        data.labels.forEach((item) => {
            let filteredData = data.paradas.filter((element) => {
                return element.parada === item;
            });

            let total = 0;
            filteredData.forEach((item) => {
                total += parseFloat(item.total);
            });

            totalGeral += total;

            dataChart.push(total);
        });

        chartData.labels = data.labels;
        chartData.datasets = [{ backgroundColor: cores, data: dataChart, label: 'Paradas' }];

        setChartData(chartData);
        setTotal(totalGeral);
    }, [data]);

    return (
        <div>
            <Button
                className="p-mt-2"
                onClick={() => setCol(col === "p-col-6" ? "p-col-12" : "p-col-6")}
                icon="pi pi-search-plus"
            />
            <div className="p-grid">
                <div className={col}>
                    <Chart
                        id="chartParadas"
                        data={chartData}
                        height="450px"
                        width={"100%"}
                        options={options}
                        plugins={[ChartDataLabels]}
                        type="bar"
                    />
                </div>
                <div className={col}>
                    <Chart
                        id="chartParadasPizza"
                        data={chartData}
                        height="450px"
                        width={"100%"}
                        options={optionsPercent}
                        plugins={[ChartDataLabels]}
                        type="doughnut"
                    />
                </div>
            </div>
        </div>
    )
});